export default __webpack_public_path__ + "static/media/bg_video.5670954a.mp4";